/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Support_Submitticket_Subject_Label1Inputs */

const en_support_submitticket_subject_label1 = /** @type {(inputs: Support_Submitticket_Subject_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subject`)
};

/**
* | output |
* | --- |
* | "Subject" |
*
* @param {Support_Submitticket_Subject_Label1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const support_submitticket_subject_label1 = /** @type {((inputs?: Support_Submitticket_Subject_Label1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Support_Submitticket_Subject_Label1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_support_submitticket_subject_label1(inputs)
});
export { support_submitticket_subject_label1 as "support_submitTicket_subject_label" }